import { Spin } from 'antd'
import React, { FC, useMemo } from 'react'
import { DamageCategory } from 'types'

import { useGetDamageCategories } from './damageCategoryAPI'

const calculateLikelihoodOfEvent = (damageCategories: DamageCategory[]) => {
  const liklihoodOfNoEventForAsset = damageCategories.reduce(
    (acc, damageCategory) => {
      if (damageCategory.probability === undefined) {
        return acc
      }
      const liklihoodOfNoEvent = 1 - damageCategory.probability
      return acc * liklihoodOfNoEvent
    },
    1
  )
  return (1 - liklihoodOfNoEventForAsset).toPrecision(4)
}

const calulateExpectedValue = (damageCategories: DamageCategory[]) => {
  return damageCategories
    .reduce((acc, damageCategory) => {
      if (
        damageCategory.consequence === undefined ||
        damageCategory.probability === undefined
      ) {
        return acc
      }
      return acc + damageCategory.consequence * damageCategory.probability
    }, 0)
    .toPrecision(4)
}

export const ExpectedValueFromDamageAreas: FC = () => {
  //fetch all damage categories tied to this site, org, component, unit
  const { damageCategoryEntries, isLoading } = useGetDamageCategories()

  const ev = useMemo(() => {
    if (!damageCategoryEntries) {
      return 0
    }
    return calulateExpectedValue(damageCategoryEntries.map((d) => d.data))
  }, [damageCategoryEntries])

  const likelihoodOfEvent = useMemo(() => {
    if (!damageCategoryEntries) {
      return 0
    }
    return calculateLikelihoodOfEvent(damageCategoryEntries.map((d) => d.data))
  }, [damageCategoryEntries])

  return (
    <Spin spinning={isLoading}>
      <div>Risk Score: {ev} </div>
      <div>Likelihood of Event: {likelihoodOfEvent}</div>
    </Spin>
  )
}
